import { ReactNode } from 'react';
import { AccordionDetails, AccordionSummary } from '@mui/material';
import { CoreBox, CoreTooltip, CoreTypography } from '@youscience/core';

import ChevronBottomIcon from '@images/chevron-bottom.svg?react';
import InfoIcon from '@images/info.svg?react';

import { sxStyles, StyledFilterAccordion } from './FilterAccordion.styles';

interface FilterAccordionProps {
  accordionTitle: string;
  tooltipInfoTitle?: string;
  children: ReactNode;
  isExpanded?: boolean;
}

export function FilterAccordion(props: FilterAccordionProps) {
  const { accordionTitle, tooltipInfoTitle = '', children, isExpanded = true, ...rest } = props;

  return (
    <StyledFilterAccordion defaultExpanded={isExpanded} disableGutters {...rest}>
      <AccordionSummary expandIcon={<ChevronBottomIcon />}>
        <CoreTypography sx={sxStyles.accordionTitle} component="div" variant="overline">
          {accordionTitle}

          {tooltipInfoTitle && (
            <CoreTooltip title={tooltipInfoTitle}>
              <CoreBox sx={sxStyles.tooltip}>
                <InfoIcon />
              </CoreBox>
            </CoreTooltip>
          )}
        </CoreTypography>
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </StyledFilterAccordion>
  );
}
